/*
 * @File
 * @Author Ngatia Frankline <fngatia@gmail.com>
 * @Created 1/29/23, 9:42 PM.
 * @Bincrud Copyright (c) 2023 All rights reserved.
 */


import '../assets/frontend/scss/index.scss'
import '../assets/frontend/js/index.js'